module.exports = __webpack_public_path__ + "IMG_8740.459bc8996729b6f6542c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/600x600/IMG_8740.jpg
// module id = ./src/assets/images/wedding/andy_jeska/600x600/IMG_8740.jpg
// module chunks = main